module.exports = __webpack_public_path__ + "static/media/graphic-element-2.bf2998e0.svg";